import { SearchableCandidateBatchSortableFieldsType } from 'services/candidate/types';

export const sortFields: SearchableCandidateBatchSortableFieldsType = {
  updatedAt: 'updatedAt',
  candidatesCount: 'candidatesCount'
};
